import React from 'react'
import styled, { css } from 'styled-components'
import { Block, Grid, H3, P } from '@mote/ui'
import { useWizard } from '../context'
import { useTrackStep } from '../hooks'
import { StepError } from './StepError'

export const Step = props => {
  const {
    children,
    title,
    subtitle,
    index,
    trackingKey = '',
    mode = 'single',
    itemsCount = 1,
    error = null
  } = props
  const { currentStep, setControlMode } = useWizard()
  const isActiveStep = React.useMemo(
    () => index === currentStep,
    [currentStep, index]
  )
  useTrackStep({ key: trackingKey, step: index, shouldTrack: isActiveStep })

  React.useEffect(() => {
    if (!isActiveStep) return
    setControlMode(mode)
  }, [isActiveStep])

  if (!isActiveStep) return null

  return (
    <Container layout='vertical' gap={24}>
      <TitleContainer layout='vertical' align='flex-start' gap={16}>
        <Title fontSize={18} lineHeight='140%' fontWeight={500} color='#25252D'>
          {title}
        </Title>
        {subtitle && (
          <Subtitle
            fontSize={15}
            lineHeight='120%'
            fontWeight='normal'
            color='#6C6C84'
          >
            {subtitle}
          </Subtitle>
        )}
      </TitleContainer>
      {error && <StepError message={error} />}
      <StyledGrid
        rows={itemsCount > 4 ? Math.floor(itemsCount / 4) : 1}
        columns={itemsCount > 4 ? 4 : itemsCount}
      >
        {children}
      </StyledGrid>
    </Container>
  )
}

const Container = styled(Block)`
  margin-top: 40px;

  @media (max-width: 640px) {
    margin-top: 16px;
  }
`
const StyledGrid = styled(Grid)`
  gap: 24px;

  ${({ columns }) =>
    columns !== 1 &&
    css`
      @media (max-width: 991px) {
        grid-template-columns: repeat(2, minmax(0, 1fr));
      }
    `}

  @media (max-width: 639px) {
    grid-template-columns: 100%;
    grid-template-rows: unset;
    gap: 16px;
  }
`

const TitleContainer = styled(Block)``
const Title = styled(H3)``
const Subtitle = styled(P)``
